import { capitalize } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { IMPACT_SCALE } from '../../../../lib/schema.js';
import RadioOptionsField from '../../../RadioOptionsField.jsx';

const options = IMPACT_SCALE.map((type) => ({
  label: capitalize(type),
  value: type,
}));

TypeField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

function TypeField({ label, name }) {
  return (
    <RadioOptionsField id="scale" label={label} name={name} options={options} />
  );
}

export default TypeField;
